import { fieldStyle, labelStyle } from './changeOrderStyles';

export default function NativeChangeOrderFields({
  context,
  jobId,
  fields,
  setField,
  files,
  fileSize,
  retainedCount,
  onFilesChange,
  disabled,
  isRevision,
}) {
  return (
    <>
      <div
        style={{
          marginTop: 12,
          padding: 11,
          background: '#fff',
          border: '1px solid #dbe3ef',
          borderRadius: 7,
          color: '#43546c',
          fontSize: 12,
          lineHeight: 1.6,
        }}
      >
        <strong>Job and contract context</strong>
        <br />
        Customer: {context?.customer_name || '—'} · {context?.customer_email || '—'} ·{' '}
        {context?.customer_phone || '—'}
        <br />
        Property: {context?.project_address || '—'} · Job {context?.job_id || jobId || '—'}
        <br />
        Contract: {context?.contract_reference || '—'} · {context?.contract_date || '—'} · Original
        price {context?.original_price ?? '—'}
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))',
          gap: 10,
          marginTop: 12,
        }}
      >
        <label style={labelStyle}>
          Change order title
          <input
            required
            maxLength={160}
            disabled={disabled}
            value={fields.title}
            onChange={(event) => setField('title', event.target.value)}
            style={fieldStyle}
          />
        </label>
        <label style={labelStyle}>
          Change number
          <input
            required
            maxLength={50}
            disabled={disabled}
            value={fields.change_number}
            onChange={(event) => setField('change_number', event.target.value)}
            style={fieldStyle}
          />
        </label>
      </div>
      <label style={{ ...labelStyle, marginTop: 10 }}>
        Scope changes
        <textarea
          required
          maxLength={16000}
          rows={4}
          disabled={disabled}
          value={fields.scope_changes}
          onChange={(event) => setField('scope_changes', event.target.value)}
          style={{ ...fieldStyle, resize: 'vertical' }}
        />
      </label>
      <label style={{ ...labelStyle, marginTop: 10 }}>
        Schedule changes (optional)
        <textarea
          maxLength={8000}
          rows={2}
          disabled={disabled}
          value={fields.schedule_changes}
          onChange={(event) => setField('schedule_changes', event.target.value)}
          style={{ ...fieldStyle, resize: 'vertical' }}
        />
      </label>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))',
          gap: 10,
          marginTop: 10,
        }}
      >
        <label style={labelStyle}>
          Price adjustment (optional)
          <input
            inputMode="decimal"
            disabled={disabled}
            placeholder="e.g. 1250.00 or -300.00"
            value={fields.price_adjustment}
            onChange={(event) => setField('price_adjustment', event.target.value)}
            style={fieldStyle}
          />
        </label>
        <label style={labelStyle}>
          Payment terms (optional)
          <input
            maxLength={8000}
            disabled={disabled}
            value={fields.payment_terms}
            onChange={(event) => setField('payment_terms', event.target.value)}
            style={fieldStyle}
          />
        </label>
      </div>
      {isRevision && (
        <div
          style={{
            marginTop: 10,
            padding: 10,
            background: '#fff',
            border: '1px solid #dbe3ef',
            borderRadius: 7,
            color: '#596a81',
            fontSize: 12,
          }}
        >
          Previous draft attachments are retained automatically. Add any new PDFs below; this saved
          revision will use a unique change number.
        </div>
      )}
      <label style={{ ...labelStyle, marginTop: 10 }}>
        PDF attachments (maximum 10 MB combined)
        <input
          type="file"
          multiple
          disabled={disabled}
          accept="application/pdf,.pdf"
          onChange={(event) => onFilesChange(Array.from(event.target.files || []))}
          style={{ ...fieldStyle, padding: 8 }}
        />
      </label>
      <p style={{ margin: '6px 0 12px', color: '#68778b', fontSize: 12, lineHeight: 1.5 }}>
        {files.length} new PDF{files.length === 1 ? '' : 's'} ·{' '}
        {(fileSize / (1024 * 1024)).toFixed(2)} MB
        {retainedCount
          ? ` · ${retainedCount} existing attachment${retainedCount === 1 ? '' : 's'} carried forward`
          : ''}
        . Attachment pages require customer initials automatically; the preview endpoint validates
        the 40-page maximum.
      </p>
      {files.length > 0 && (
        <ul style={{ margin: '-4px 0 12px', paddingLeft: 20, color: '#596a81', fontSize: 12 }}>
          {files.map((file) => (
            <li key={`${file.name}-${file.size}`}>{file.name}</li>
          ))}
        </ul>
      )}
    </>
  );
}
